module.exports = {
      id: "comm-news-usage",
      viewBox: "0 0 223.506 38.837",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-news",
      toString: function () {
        return this.url;
      }
    }